import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setCurPageAction } from '../../modules/common/prodModule';

const PaginationBlock = styled.div`
    position: relative;
    .page-list button {
        max-width: 36px;
        max-height: 36px;
        //border-bottom: 2px solid transparent;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        width: 10vw;
        height: 10vw;
    }

    .page-btn {
        max-width: 36px;
        max-height: 36px;
        width: 10vw;
        height: 10vw;
    }

    .page-right {
        position: absolute;
        right: 0;
        top: 0;
    }

    .page-left {
        position: absolute;
        left: 0;
        top: 0;
    }
`;

const RIGHT_PAGE = '...';

/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */
const range = (from, to, step = 1) => {
    let i = from;
    let range = [];

    while (i <= to) {
        range.push(i);
        i += step;
    }

    return range;
}

const PaginationMobile = ({ updatePageNum, prodItems }) => {

    const dispatch = useDispatch();

    if(prodItems === null || prodItems === undefined 
        || prodItems.paging === null || prodItems.paging === undefined
        || prodItems.paging.curPage === 0 || prodItems.paging.curPage === null || prodItems.paging.curPage === undefined){
            return <PaginationBlock />
        }
 
    const fetchPageNumbers = () => {

        const showPageNum = 5;


        if (prodItems.paging.totalPage > showPageNum) {

            let pages = range(prodItems.paging.startPage, prodItems.paging.endPage);
            // console.log("totalPage : " + totalPage + " , start : " + startPage + ", endPage : " + endPage + ", pages : " + pages)

            // ... 표시
            // 남은 페이지가 9 보다 클 경우 
            /* if (prodItems.paging.totalPage - prodItems.paging.startPage > 9) {
                if (prodItems.paging.startPage !== 1) {
                    pages = [1, ...pages, RIGHT_PAGE, prodItems.paging.totalPage];
                } else {
                    pages = [...pages, RIGHT_PAGE, prodItems.paging.totalPage];
                }

            } */
            return pages;
        }

        return range(1, prodItems.paging.totalPage);

    }

    // 표시할 페이지 가져오기 
    const pages = fetchPageNumbers();

    // 페이지 번호 클릭 
    const handleClickPage = (page) => {

        if (page !== RIGHT_PAGE) {
            updatePageNum(page);
            // dispatch(setCurPageAction(page));
        }

    }

    // Next Button Click
    const handleNextClick = () => {

        // console.log("handleNextClick +++++ " + endPage);
        if (prodItems.paging.endPage < prodItems.paging.totalPage) {
            updatePageNum(prodItems.paging.endPage + 1);
            // dispatch(setCurPageAction(endPage + 1));
        }
    }

    // Prev Button Click
    const handlePrevClick = () => {

        // console.log("handlePrevClick +++++ " + startPage);
        if (prodItems.paging.startPage > 1) {
            updatePageNum(prodItems.paging.startPage - 1);
            // dispatch(setCurPageAction(startPage - 10));
        }
    }

    const handlePrev1stClick = () => {
        updatePageNum(1);
    }

    const handleNextEndClick = () => {
        updatePageNum(prodItems.paging.totalPage);
    }

    const handleDisplayPre = () => {
        if(prodItems.paging.totalPage === 1){
            return "none";
        }
        else if(prodItems.paging.totalPage < 6){
            return "none";
        }
        else if(prodItems.paging.endPage === 5) {
            return "none"
        }

        return "block";
    }

    const handleDisplayNext = () => {
        if(prodItems.paging.totalPage === 1){
            return "none";
        }
        else if(prodItems.paging.totalPage < 6){
            return "none";
        }
        else if(prodItems.paging.totalPage === prodItems.paging.endPage){
            return "none"
        }

        return "block"

    }

    if(prodItems.paging.totalPage === 0){
        return (<PaginationBlock></PaginationBlock>);
    }

    return (
        <PaginationBlock>
            <div className="page-left">
                <button style = { {display:handleDisplayPre()}} type="button" className="page-btn prev1st" onClick={() => { handlePrev1stClick() }}></button>
                <button style = { {display:handleDisplayPre()}} type="button" className="page-btn prev" onClick={() => { handlePrevClick() }}></button>
            </div>
            <div className="margin_b-20 text_center">
                <div className="page-wrap">
                    {/* <button style = { {display:handleDisplayPre()}} type="button" className="page-btn prev1st" onClick={() => { handlePrev1stClick() }}></button>
                    <button style = { {display:handleDisplayPre()}} type="button" className="page-btn prev" onClick={() => { handlePrevClick() }}></button> */}
                    <div className="page-list">
                        {
                            pages.map((page, index) => {
                                return (
                                    <span key={page} className={page === (prodItems.paging.curPage * 1) ? "active" : ""}>
                                        <button type="button" onClick={() => { handleClickPage(page) }}>{page}</button>
                                    </span>
                                )
                            })
                        }
                    </div>
                    {/* <button style = { {display:handleDisplayNext()}} type="button" className="page-btn next" onClick={() => { handleNextClick() }}></button>
                    <button style = { {display:handleDisplayNext()}} type="button" className="page-btn nextEnd" onClick={() => { handleNextEndClick() }}></button> */}
                </div>
            </div>
            <div className="page-right">
                <button style = { {display:handleDisplayNext()}} type="button" className="page-btn next" onClick={() => { handleNextClick() }}></button>
                <button style = { {display:handleDisplayNext()}} type="button" className="page-btn nextEnd" onClick={() => { handleNextEndClick() }}></button>
            </div>
        </PaginationBlock>
    );
};

export default PaginationMobile;